export default __webpack_public_path__ + "static/media/TheScarf_01.1bfa976c.png";